var _defs, _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 89 89",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsVectornator: "http://vectornator.io",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 89,
    width: 89,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ArtboardFrame)",
    id: "Untitled",
    vectornatorLayerName: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.976 44.5341L27.0041 44.4708L41.8181 30.346L42.0292 66.0295L46.5728 66.0788L46.2827 30.301L61.3734 44.4957L67.024 44.5225L44.0352 22.9212L21.976 44.5341Z",
    fill: "#f56400",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 44.5C1 20.4756 20.4756 1 44.5 1C68.5244 1 88 20.4756 88 44.5C88 68.5244 68.5244 88 44.5 88C20.4756 88 1 68.5244 1 44.5Z",
    fill: "#f56400",
    fillOpacity: 0,
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#f56400",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.baa59f42b2d79bec53ca65f83ac3914d.svg";
export { ForwardRef as ReactComponent };